import { Types } from '@store/types';

const initialState = {
	id: null,
	mergeProductList: [],
	isShowMergeTechPack: false,
	onCloseViewModal: () => false,
	updateProductStatus: () => false,
	source: '',
	orderId: null,
	selectedCommentId: null,
	designIdList: [],
	loadMoreDesign: false,
	onLastDesignReached: () => false,
	onUpdateCostingStatus: () => false,
	initialCostingId: null,
	costingItemList: [],
	isCostingRequestFromBuyer: false,
	onBasicInfoUpdateSuccess: () => false,
	isDefaultOpenBasicInfo: false,
	isOpenCommentPanel: false,
	isShowCostingPanel: false,
	isShowCostingButton: false,
	isSoldFolder: false
};

const DesignViewModalReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_DESIGN_VIEW_MODAL_INFO:
			return action.payload;
		case Types.UPDATE_DESIGN_VIEW_MODAL_INFO:
			return { ...state, ...action.payload };
		case Types.CLEAR_DESIGN_VIEW_MODAL_INFO:
			return {};
		default:
			return state;
	}
};

export default DesignViewModalReducer;
